import { EDITOR_COPY } from './agent-templates-copy';
import styles from './UnavailableGrantRow.module.css';

interface UnavailableGrantRowProps {
  label: string;
  disabled: boolean;
  busy: boolean;
  onRemove: () => void;
}

export const UnavailableGrantRow = ({ label, disabled, busy, onRemove }: UnavailableGrantRowProps) => (
  <div className={styles.unavailable}>
    <span>{label}</span>
    <button type="button" disabled={disabled} aria-busy={busy} onClick={onRemove}>
      {EDITOR_COPY.remove}
    </button>
  </div>
);
